export default __webpack_public_path__ + "static/media/finance1.fa757bc1.svg";